import React, { useState, useEffect } from "react"
import { Layout, Menu, Select, Switch, Tabs } from 'antd';
import images from '../../themes/appImage'
import { BrowserRouter as Router, Link, useNavigate } from "react-router-dom";
import { Table, Breadcrumb, Modal } from 'antd';
import appconstant from "../../themes/appconstant";
import Textfiled from "../../common";


const { Header, Content, Footer, Sider } = Layout;

const handleChange = (value) => {
    console.log(`selected ${value}`);
};

const Playlists
    = () => {

        const [modal1Open, setModal1Open] = useState(false);


        const navigate = useNavigate()

        // switch
        const onChange3 = (checked) => {
            console.log(`switch to ${checked}`);
        };

        //   


        useEffect(() => {
            document.title = 'MentalFit';
        }, [])



        return (
            <div>
                <div className="site-layout-background" style={{ minHeight: 360 }}>

                    <div className="top-header-organi-zations">
                        <div className="organi-zations-heading-text">
                            <h1>Playlists</h1>
                            <Breadcrumb separator=">">

                                <Breadcrumb.Item>
                                    <Link to="/tools"> Tools </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    {appconstant.playlists}
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                    </div>



                    <section>
                        <div className=" manage-table-data">
                            <div className="log-moode-page-sec">


                                <div className="">
                                    <div className="widget-grid-sec">
                                        <div className="create-inner-circle new-wid add-playlist">
                                            <p><span> <img src={images.add} alt="add" /></span>Add new </p>
                                        </div>

                                        <div className="import-play-list">
                                            <h1><span><img src={images.spotify} alt="spotify" /> </span> Import Pandora Playlist</h1>
                                            <div className="import-pandora-playlist">
                                                <div className="switch-btn switch-btn-op">
                                                    <Switch defaultChecked onChange={onChange3} />
                                                    <p>Enable</p>
                                                </div>
                                                <div className="setting-option">
                                                    <img src={images.horizontalDots} alt="horizontalDots" />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="import-play-list">
                                            <h1><span><img src={images.apple} alt="groupIcons" /> </span> Import Apple Playlist</h1>
                                            <div className="import-pandora-playlist">
                                                <div className="switch-btn switch-btn-op">
                                                    <Switch defaultChecked onChange={onChange3} />
                                                    <p>Enable</p>
                                                </div>
                                                <div className="setting-option">
                                                <img src={images.horizontalDots} alt="horizontalDots" />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="import-play-list">
                                            <h1><span><img src={images.amazon} alt="amazon" /> </span> Import Amazon Playlist </h1>
                                            <div className="import-pandora-playlist">
                                                <div className="switch-btn switch-btn-op">
                                                    <Switch defaultChecked onChange={onChange3} />
                                                    <p>Enable</p>
                                                </div>
                                                <div className="setting-option">
                                                <img src={images.horizontalDots} alt="horizontalDots" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>



                </div>




            </div>

        )
    }
export default Playlists

